<template>
    <div class="" >
      <v-btn small class="mx-4" @click="$router.back()" color="info" tile outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
      </v-btn>
  
      <h4 class="text-center">Oferta Academica</h4>
      <v-progress-linear v-if="loading" indeterminate />  

      <v-row>
        <v-col class="col-sm-2">
            <v-select
            :items="anios_matriculacion"
            v-model="anio_matriculacion"
            label="Año de matriculacion"
            outlined
            dense
            style="z-index: 11;"
          />
        </v-col>
        <v-col class="col-sm-2">
          <v-select
            :items="['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']"
            v-model="mes_matriculacion"
            label="Mes de matriculacion"
            outlined
            dense
            multiple
            hide-details
            style="z-index: 11;"
            />
        </v-col>
        <v-col class="col-sm-2 col-lg-1">
          <v-checkbox v-if="mes_matriculacion.length<=1" v-model="desde_mes_seleccionado" label="Es Igual" hide-details dense/>
        </v-col>
        <v-col cols="2">
          <v-combobox
            v-model="sede"
            :items="sedes"
            label="Sedes"
            item-text="nombre"
            multiple
            chips
            outlined
            dense
            hide-details
            clearable
          >
            <template v-slot:selection="data">
              <v-chip
                :key="JSON.stringify(data.item)"
                v-bind="data.attrs"
                :input-value="data.selected"
                :disabled="data.disabled"
                @click:close="data.parent.selectItem(data.item)"
              >
                <v-avatar
                  class="accent white--text"
                  left
                  v-text="data.item.nombre.slice(0, 1).toUpperCase()"
                ></v-avatar>
                {{ data.item.nombre }}
              </v-chip>
            </template>
          </v-combobox>
        </v-col>
        
        <v-col class="col-sm-2">
          <v-btn class="green darken-3" dark tile dense @click="appFiltro()">Filtrar</v-btn>
        </v-col>
        <v-col class="col-sm-2">
          <button 
            v-show="promociones.length > 0"
            class="btn btn-sm btn-link"
            @click="tableToExcel('table', 'Lorem Table')">
            <span class="glyphicon glyphicon-print"></span> Descargar EXCEL.
          </button>
        </v-col>
          
      </v-row>
      

      <v-row no-gutters>
        <v-col class="col-sm-6">
          <v-text-field v-if="promociones.length"
            v-model="search"
            append-icon="mdi-magnify"
            label="filtrar en la tabla ..." 
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      
      <div xstyle="height: 50vh;width:95%;overflow-x: hidden;position: relative;">
        <v-data-table ref="table" :headers="headers" :search="search" fixed-header hide-default-footer height="72vh" :items="promociones" dense :itemsPerPage="-1" class="elevation-1">
          <template v-slot:item.precios_real_contrado="{ item }">
            <p v-for="(p,ind) in item.precios_real_contrado" :key="ind" class="my-0 pt-0 pb-4" style="font-size: 0.85em;">
              {{ p }}
            </p>
          </template>
          <template v-slot:item.precios_real_credito="{ item }">
            <p v-for="(p,ind) in item.precios_real_credito" :key="ind" class="my-0 pt-0 pb-4" style="font-size: 0.85em;">
              {{ p }}
            </p>
          </template>
          <template v-slot:body.append="{ headers }" >
            <tr>
              <td></td>
              <td>TOTALES</td>
              <td></td>
              <td></td>
              <td> </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td> {{ totales.dias_oferta_vigente }} </td>
              <td> {{ totales.dias_limite }} </td>
              <td></td>
              <td></td>
              <td> {{ totales.cantidad_inscritos }} </td>
              <td> {{ totales.cantidad_inscritos_incompleto }} </td>
              <td> {{ totales.cantidad_pre_inscritos }} </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </v-data-table>
      </div>
  
    </div>
  </template>

<style>
  .v-data-table-header {
    background: green!important;  
  } 
  .v-data-table-header th { 
    color: white !important;
    background: green!important;  
  }
  .v-data-table__wrapper tr:nth-child(odd) {
    background-color: #f5f5f5!important; 
  }
  .v-data-table__wrapper tr:last-child {
    background: green!important;  
    color: white !important;
  }
  .v-data-table__wrapper tr:last-child td {
    background: green!important;  
    color: white !important;
  }  

  .v-data-table__wrapper {
    position: relative;
    overflow: auto;
    max-width: 100%;
  }

  .v-data-table__wrapper table {
    width: 100%;
  } 

  .v-data-table__wrapper thead th:nth-child(-n+3){
    z-index: 10!important;
  }

  .v-data-table__wrapper thead th:nth-child(-n+3),
  .v-data-table__wrapper tbody td:nth-child(-n+3) {
    position: sticky;
    left: 0;
    z-index: 1;
    background-color: #ffffff;
  }  
  #main-contentid { 
      overflow-x: hidden;
  }
</style>
  
  <script> 
    import xaxios from '@/xaxios';
    import gql from 'graphql-tag'
    export default {
      data: () => ({
        loading: false,
        promociones: [{}],
        posgrado: null,
        anios_matriculacion: [2017,2018,2019,2020,2021,2022,2023,2024],
        mes_matriculacion: [],
        anio_matriculacion: 0,
        desde_mes_seleccionado: false,
        sede: [],
        sedes:[],
        totales:{
          cantidad_inscritos:0,
          cantidad_inscritos_incompleto:0,
          cantidad_pre_inscritos:0,
          dias_limite:0,
          dias_oferta_vigente:0,
        },
        search: null,
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL
        headers: [
          { text: '#', value: 'ind', width: 20, sortable: true },
          { text: 'Sede', value: 'sede', width: 40, sortable: true },
          { text: 'Nombre del programa', value: 'programa', width: 120, sortable: true },
          { text: 'Mes Oferta', value: 'mes', sortable: true },
          { text: 'Convenio', value: 'universidad', width: 120, sortable: true },
          { text: 'Area de programa', value: 'area', width: 120, sortable: true },
          { text: 'Tipo de programa', value: 'categoria', width: 120, sortable: true },
          { text: 'Codigo del programa', value: 'codigo', width: 120, sortable: true },
          { text: 'Estado', value: 'estado', width: 120, sortable: true },
          { text: 'Modalidad', value: 'modalidad', width: 120, sortable: true },
          { text: 'Tipo de desarrollo', value: 'tipo', width: 120, sortable: true },

          // { text: 'Observaciones de programacion', value: 'observaciones_programacion', width: 120, sortable: true }, // 
          { text: 'Fecha de inicio de campaña', value: 'fecha_matriculacion', width: 120, sortable: true },
          { text: 'Fecha de culminacion de campaña', value: 'fecha_culminacion', width: 120, sortable: true },
          { text: 'Fecha inicio del modulo 0', value: 'fecha_inicio_modulo_cero', width: 120, sortable: true },
          { text: 'Fecha inicio del modulo 1', value: 'fecha_inicio_modulo_uno', width: 120, sortable: true },
          // { text: 'Proyeccion de inscritos', value: 'cantidad_inscritos', width: 120, sortable: true },
          // { text: 'Numero de inscritos a la fecha', value: 'inscritos', width: 120, sortable: true }, //
          { text: 'Fecha del primer inscrito', value: 'fecha_primer_inscrito', width: 120, sortable: true },
          { text: 'Dias de oferta vigente', value: 'dias_oferta_vigente', width: 120, sortable: true },
          { text: 'Dias limite', value: 'dias_limite', width: 120, sortable: true },
          { text: 'Estado final', value: 'estado_final', width: 120, sortable: true },
          { text: 'Coordinador a cargo', value: 'coordinador', width: 120, sortable: true },
          { text: 'Cantidad inscritos', value: 'cantidad_inscritos', width: 120, sortable: true },
          { text: 'Cantidad inscritos incompleto', value: 'cantidad_inscritos_incompleto', width: 120, sortable: true },
          { text: 'Cantidad preinscritos', value: 'cantidad_pre_inscritos', width: 120, sortable: true },
          { text: 'Precio Real Al contado', value: 'precios_real_contrado', width: 120, sortable: true },
          { text: 'Precio Real a cuotas', value: 'precios_real_credito', width: 120, sortable: true },
          // { text: 'Estado de brochure', value: 'estado_brochure', width: 120, sortable: true },//

          /* { text: 'Link brochure', value: 'link_brochure', width: 120, sortable: true },//
          { text: 'Codigo Sistema Esam', value: 'codigo_esam', width: 120, sortable: true },//
          { text: 'Observaciones', value: 'observaciones', width: 120, sortable: true },//
          { text: 'Seguimiento 1', value: 'seguimiento_1', width: 120, sortable: true },//
          { text: 'Seguimiento 2', value: 'seguimiento_2', width: 120, sortable: true },//
          { text: 'Seguimiento 3', value: 'seguimiento_3', width: 120, sortable: true },//
          { text: 'Seguimiento 4', value: 'seguimiento_4', width: 120, sortable: true },//
          { text: 'Seguimiento 5', value: 'seguimiento_5', width: 120, sortable: true }, // */
          { text: 'Modulo', value: 'modulo', width: 120 }, 
        ],
      }),
  
      components: { },
      computed: {},
      watch: {
        '$store.state.CARGO.sede.unidad_negocio': function(){
          this.getSedes(); 
        }, 
      },
      methods: {  
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table.$el.children[0].children[0];
        window.console.log('table',table);
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_OFERTA_ACADEMICA.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
       getmes(){
        const ids = [];
        if(this.mes_matriculacion.includes('enero')) ids.push(1);
        if(this.mes_matriculacion.includes('febrero')) ids.push(2);
        if(this.mes_matriculacion.includes('marzo')) ids.push(3);
        if(this.mes_matriculacion.includes('abril')) ids.push(4);
        if(this.mes_matriculacion.includes('mayo')) ids.push(5);
        if(this.mes_matriculacion.includes('junio')) ids.push(6);
        if(this.mes_matriculacion.includes('julio')) ids.push(7);
        if(this.mes_matriculacion.includes('agosto')) ids.push(8);
        if(this.mes_matriculacion.includes('septiembre')) ids.push(9);
        if(this.mes_matriculacion.includes('octubre')) ids.push(10);
        if(this.mes_matriculacion.includes('noviembre')) ids.push(11);
        if(this.mes_matriculacion.includes('diciembre')) ids.push(12);
        //window.console.log('this.mes_matriculacion',this.mes_matriculacion, ids);
        return ids;
       },
       getSedeArray(){
        const ss = [];
        this.sede.forEach(s=>ss.push(s.id));
        return ss;
       },
       async getSedes() {
          const idunidad = this.$store.state.CARGO.sede.unidad_negocio;
          const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio}}`;
          let s = await this.$apollo.query({ query: qs })
            .then(({ data: { getSedes } }) => getSedes.length ? getSedes:[]).catch(() => []);
          s = s.filter(s=>s.unidad_negocio==idunidad)
          this.sedes = s;
        },
        appFiltro(){
          let mes = this.getmes();
          let ss = this.getSedeArray();
          //window.console.log('mes', mes);
          if(mes.length==0){ 
            this.$root.$notify.show(`Seleccione el mes`, {color: 'red',x: 'right',});
            return;
          }
          if(!this.anio_matriculacion) {
            this.$root.$notify.show(`Seleccione el año`, {color: 'red',x: 'right',});
            return;
          }
          this.getpromos(mes,this.anio_matriculacion,ss)
        },
        getpromos(mes, anio,idsedes) {
          const idunidad = this.$store.state.CARGO.sede.unidad_negocio;
          this.loading = true;
          let vue = this;
          this.promociones = []; 
          this.totales = {};
          let sedesid = '';
          let xmes = '';
          let negocio = "&unidad_negocio_id="+idunidad;
          if(idsedes.length > 1) sedesid = `&sedes_id=${idsedes}`;
          if(idsedes.length == 1) sedesid = `&sede_id=${idsedes}`;
          if(idsedes.length == 0) sedesid = `&sede_id=0`;
          if(mes.length > 1) xmes = `meses_matriculacion=${mes}`;
          if(mes.length == 1) xmes = `mes_matriculacion=${mes}`;
          let xurl = `/api/v1/inscripcion/oferta-academica?${xmes}&anio_matriculacion=${anio}&is_igual=${this.desde_mes_seleccionado}${sedesid}${negocio}`
          var config = {
            method: 'get',
            url: `${process.env.VUE_APP_API_REST}${xurl}`,
            headers: {},
          };
  
          xaxios.request(config)
            .then(function (response) {
              let data = response.data.data;
              // window.console.log(data);
              if(!data){
                vue.loading = false;
                return;
              }
              data.reverse().map((x,i)=>{
                x.ind = i+1;
                x.precios_real_contrado = x.precios_real_contrado.split(',');
                x.precios_real_credito = x.precios_real_credito.split(',');
              })
              const ultimo = {...data[0]};
              ultimo.ind = '';
              ultimo.id = 10000;
              ultimo.sede = 'TOTALES';
              ultimo.programa = '';
              ultimo.mes = '';
              ultimo.universidad = '';
              ultimo.area = '';
              ultimo.categoria = '';
              ultimo.codigo = '';
              ultimo.estado = '';
              ultimo.modalidad = '';
              ultimo.tipo = '';
              ultimo.fecha_matriculacion = '';
              ultimo.fecha_culminacion = '';
              ultimo.fecha_inicio_modulo_cero = '';
              ultimo.fecha_inicio_modulo_uno = '';
              ultimo.fecha_primer_inscrito = '';
              ultimo.estado_final = '';
              ultimo.coordinador = '';
              ultimo.precios_real_contrado = '';
              ultimo.precios_real_credito = '';
              ultimo.dias_limite = parseInt(ultimo.dias_limite);
              ultimo.dias_oferta_vigente = parseInt(ultimo.dias_oferta_vigente);
              ultimo.cantidad_inscritos = 0;
              ultimo.cantidad_inscritos_incompleto = 0;
              ultimo.cantidad_pre_inscritos = 0; 
              data.forEach(x=>{
                for (let key in x) {
                  if (x.hasOwnProperty(key)) {
                    if(key=='cantidad_inscritos') ultimo.cantidad_inscritos += parseInt(x[key]);
                    else if(key=='cantidad_inscritos_incompleto') ultimo.cantidad_inscritos_incompleto += parseInt(x[key]);
                    else if(key=='cantidad_pre_inscritos') ultimo.cantidad_pre_inscritos += parseInt(x[key]);
                    else if(key=='dias_limite') ultimo.dias_limite += parseInt(x[key]);
                    else if(key=='dias_oferta_vigente') ultimo.dias_oferta_vigente += parseInt(x[key]); 
                  }
                }
                
              })
              // window.console.log('totales',vue.totales);
              vue.totales.cantidad_inscritos = ultimo.cantidad_inscritos;
              vue.totales.cantidad_inscritos_incompleto = ultimo.cantidad_inscritos_incompleto;
              vue.totales.cantidad_pre_inscritos = ultimo.cantidad_pre_inscritos;
              vue.totales.dias_limite = ultimo.dias_limite;
              vue.totales.dias_oferta_vigente = ultimo.dias_oferta_vigente;
              //data.push(ultimo);
              vue.promociones = data;
              vue.loading = false;
              setTimeout(() => {
                vue.setLeft();
              }, 800);
            })
            .catch(function (error) {
              window.console.log(error);
              vue.loading = false;
            });
        },
        setLeft(){
          let celdash = document.querySelectorAll('.v-data-table-header th:nth-child(3)');
          let celdas0 = document.querySelectorAll('.v-data-table__wrapper tbody td:nth-child(2)');
          let celdas1 = document.querySelectorAll('.v-data-table__wrapper tbody td:nth-child(3)');
          if (celdas1.length > 0) {
            let dx = -70;
            let primerAncho = celdas1[0].offsetWidth + dx;
            for (let i = 0; i < celdas1.length; i++){
              celdas1[i].style.left = primerAncho+'px';
              if( i%2 == 0 ) {
                celdas0[i].style.background = '#f5f5f5';
                celdas1[i].style.background = '#f5f5f5';
              }
            }
            celdash[0].style.left = primerAncho+'px';
          }  
        }
      },
      mounted() {
        let date = new Date();
        //let mes = date.getMonth()+1;
        let anio = date.getFullYear();
        this.anio_matriculacion = anio;
        this.getSedes();
        
      },
    };
  </script>
  